import { FeatureToggleClientService } from 'feature-toggle-client';
import { ldclientSdkKey, ldProxyBaseUrl, ldProxyEventsUrl, ldProxyClientStream, ldStreamReconnectDelay, } from 'app.constants';
import { PromiseFactory } from 'modules/application/misc/PromiseFactory';
export class InitializeUserService {
    static $inject = ['AccountService2', 'UpdatesService', '$window', '$rootScope'];
    constructor(AccountService2, UpdatesService, $window, $rootScope) {
        'ngInject';
        this.AccountService2 = AccountService2;
        this.UpdatesService = UpdatesService;
        this.$window = $window;
        this.$rootScope = $rootScope;
    }
    async initFeatureToggle() {
        if (this.initializationPromise === undefined) {
            this.initializationPromise = PromiseFactory.new({});
        }
        else {
            await this.initializationPromise.promise;
            return this.client;
        }
        const featureToggleInstance = FeatureToggleClientService.getInstance();
        const me = await this.AccountService2.me();
        featureToggleInstance.initializeUser(me, ldclientSdkKey, {
            baseUrl: ldProxyBaseUrl,
            eventsUrl: ldProxyEventsUrl,
            streamUrl: ldProxyClientStream,
            streamReconnectDelay: ldStreamReconnectDelay,
        });
        await featureToggleInstance.getUserInstance().waitUntilReady();
        this.updateSessionStorage();
        this.client = featureToggleInstance.getUserInstance();
        this.client.on('change', (changedFlags) => this.UpdatesService.onUpdate(changedFlags));
        this.$rootScope.featureToggleInitialized = true;
        this.initializationPromise.resolve();
        return this.client;
    }
    async initAnonymousFeatureToggle() {
        const featureToggleInstance = FeatureToggleClientService.getInstance();
        featureToggleInstance.initializeUser({ anonymous: true }, ldclientSdkKey, {
            baseUrl: ldProxyBaseUrl,
            eventsUrl: ldProxyEventsUrl,
            streamUrl: ldProxyClientStream,
            streamReconnectDelay: ldStreamReconnectDelay,
        });
        await featureToggleInstance.getUserInstance().waitUntilReady();
        this.updateSessionStorage();
        this.client = featureToggleInstance.getUserInstance();
        this.client.on('change', (changedFlags) => this.UpdatesService.onUpdate(changedFlags));
        this.$rootScope.featureToggleInitialized = true;
        this.initializationPromise.resolve();
        return this.client;
    }
    static async InitAnonymousFeatureToggle() {
        const featureToggleInstance = FeatureToggleClientService.getInstance();
        featureToggleInstance.initializeUser({ anonymous: true }, ldclientSdkKey, {
            baseUrl: ldProxyBaseUrl,
            eventsUrl: ldProxyEventsUrl,
            streamUrl: ldProxyClientStream,
            streamReconnectDelay: ldStreamReconnectDelay,
        });
        await featureToggleInstance.getUserInstance().waitUntilReady();
        return featureToggleInstance.getUserInstance();
    }
    updateSessionStorage() {
        this.$window.sessionStorage.removeItem('update-toast-shown');
        this.$window.sessionStorage.setItem('feature-toggle-initialization-timespan', Date.now().toString());
    }
}
InitializeUserService.$inject = ['AccountService2', 'UpdatesService', '$window', '$rootScope'];
